/**
 * Arabic Translations - الترجمة العربية
 * =====================================
 */

export const ar = {
  // ═══════════════════════════════════════════════════════════
  // عام - General
  // ═══════════════════════════════════════════════════════════
  general: {
    appName: 'وترلي',
    loading: 'جاري التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    create: 'إنشاء',
    update: 'تحديث',
    search: 'بحث',
    filter: 'تصفية',
    clear: 'مسح',
    reset: 'إعادة تعيين',
    confirm: 'تأكيد',
    close: 'إغلاق',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    submit: 'إرسال',
    continue: 'متابعة',
    finish: 'إنهاء',
    yes: 'نعم',
    no: 'لا',
    ok: 'حسناً',
    all: 'الكل',
    none: 'لا شيء',
    select: 'اختر',
    selectAll: 'تحديد الكل',
    deselectAll: 'إلغاء تحديد الكل',
    noResults: 'لا توجد نتائج',
    noData: 'لا توجد بيانات',
    required: 'مطلوب',
    optional: 'اختياري',
    more: 'المزيد',
    less: 'أقل',
    showMore: 'عرض المزيد',
    showLess: 'عرض أقل',
    viewAll: 'عرض الكل',
    details: 'التفاصيل',
    actions: 'الإجراءات',
    status: 'الحالة',
    date: 'التاريخ',
    time: 'الوقت',
    from: 'من',
    to: 'إلى',
    total: 'المجموع',
    items: 'عناصر',
    page: 'صفحة',
    of: 'من',
    rows: 'صفوف',
    perPage: 'لكل صفحة',
  },

  // ═══════════════════════════════════════════════════════════
  // المصادقة - Authentication
  // ═══════════════════════════════════════════════════════════
  auth: {
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    register: 'إنشاء حساب',
    forgotPassword: 'نسيت كلمة المرور؟',
    resetPassword: 'إعادة تعيين كلمة المرور',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    rememberMe: 'تذكرني',
    loginSuccess: 'تم تسجيل الدخول بنجاح',
    logoutSuccess: 'تم تسجيل الخروج بنجاح',
    invalidCredentials: 'بيانات الدخول غير صحيحة',
    sessionExpired: 'انتهت الجلسة، الرجاء تسجيل الدخول مجدداً',
    welcomeBack: 'مرحباً بعودتك',
    signInToContinue: 'سجل دخولك للمتابعة',
  },

  // ═══════════════════════════════════════════════════════════
  // النماذج - Forms
  // ═══════════════════════════════════════════════════════════
  forms: {
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    fullName: 'الاسم الكامل',
    phone: 'رقم الجوال',
    address: 'العنوان',
    city: 'المدينة',
    country: 'الدولة',
    postalCode: 'الرمز البريدي',
    description: 'الوصف',
    notes: 'ملاحظات',
    attachments: 'المرفقات',
    uploadFile: 'رفع ملف',
    dragAndDrop: 'اسحب وأفلت الملفات هنا',
    or: 'أو',
    browse: 'استعراض',
    maxFileSize: 'الحد الأقصى لحجم الملف',
    allowedTypes: 'الأنواع المسموحة',
  },

  // ═══════════════════════════════════════════════════════════
  // التحقق - Validation
  // ═══════════════════════════════════════════════════════════
  validation: {
    required: 'هذا الحقل مطلوب',
    email: 'البريد الإلكتروني غير صالح',
    minLength: 'يجب أن يكون على الأقل {min} أحرف',
    maxLength: 'يجب ألا يتجاوز {max} أحرف',
    minValue: 'يجب أن يكون على الأقل {min}',
    maxValue: 'يجب ألا يتجاوز {max}',
    pattern: 'التنسيق غير صحيح',
    passwordMismatch: 'كلمتا المرور غير متطابقتين',
    passwordStrength: 'كلمة المرور ضعيفة',
    invalidPhone: 'رقم الجوال غير صالح',
    invalidDate: 'التاريخ غير صالح',
    futureDate: 'يجب أن يكون التاريخ في المستقبل',
    pastDate: 'يجب أن يكون التاريخ في الماضي',
  },

  // ═══════════════════════════════════════════════════════════
  // الرسائل - Messages
  // ═══════════════════════════════════════════════════════════
  messages: {
    success: 'تمت العملية بنجاح',
    error: 'حدث خطأ، حاول مرة أخرى',
    warning: 'تحذير',
    info: 'معلومة',
    confirmDelete: 'هل أنت متأكد من الحذف؟',
    confirmAction: 'هل أنت متأكد من هذا الإجراء؟',
    unsavedChanges: 'لديك تغييرات غير محفوظة',
    discardChanges: 'هل تريد تجاهل التغييرات؟',
    savedSuccessfully: 'تم الحفظ بنجاح',
    deletedSuccessfully: 'تم الحذف بنجاح',
    updatedSuccessfully: 'تم التحديث بنجاح',
    createdSuccessfully: 'تم الإنشاء بنجاح',
    operationFailed: 'فشلت العملية',
    networkError: 'خطأ في الاتصال بالشبكة',
    serverError: 'خطأ في الخادم',
    unauthorized: 'غير مصرح لك بهذا الإجراء',
    forbidden: 'ممنوع الوصول',
    notFound: 'غير موجود',
    timeout: 'انتهت مهلة الطلب',
  },

  // ═══════════════════════════════════════════════════════════
  // التاريخ والوقت - Date & Time
  // ═══════════════════════════════════════════════════════════
  dateTime: {
    today: 'اليوم',
    yesterday: 'أمس',
    tomorrow: 'غداً',
    thisWeek: 'هذا الأسبوع',
    lastWeek: 'الأسبوع الماضي',
    thisMonth: 'هذا الشهر',
    lastMonth: 'الشهر الماضي',
    thisYear: 'هذا العام',
    lastYear: 'العام الماضي',
    custom: 'مخصص',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    selectDate: 'اختر التاريخ',
    selectTime: 'اختر الوقت',
    am: 'ص',
    pm: 'م',
    days: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    daysShort: ['أحد', 'إثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
    months: [
      'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
      'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
    ],
    monthsShort: [
      'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
      'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
    ],
  },

  // ═══════════════════════════════════════════════════════════
  // الجداول - Tables
  // ═══════════════════════════════════════════════════════════
  table: {
    showing: 'عرض',
    entries: 'عناصر',
    noRecords: 'لا توجد سجلات',
    loading: 'جاري تحميل البيانات...',
    sortAsc: 'ترتيب تصاعدي',
    sortDesc: 'ترتيب تنازلي',
    export: 'تصدير',
    print: 'طباعة',
    columns: 'الأعمدة',
    refresh: 'تحديث',
  },

  // ═══════════════════════════════════════════════════════════
  // الطلبات - Orders
  // ═══════════════════════════════════════════════════════════
  orders: {
    order: 'طلب',
    orders: 'الطلبات',
    newOrder: 'طلب جديد',
    orderNumber: 'رقم الطلب',
    orderDate: 'تاريخ الطلب',
    orderStatus: 'حالة الطلب',
    orderDetails: 'تفاصيل الطلب',
    quantity: 'الكمية',
    liters: 'لتر',
    waterType: 'نوع المياه',
    drinkingWater: 'مياه شرب',
    groundWater: 'مياه جوفية',
    deliveryAddress: 'عنوان التوصيل',
    scheduledTime: 'الوقت المحدد',
    estimatedArrival: 'الوصول المتوقع',
    price: 'السعر',
    totalPrice: 'السعر الإجمالي',
    paymentMethod: 'طريقة الدفع',
    cash: 'نقداً',
    card: 'بطاقة',
    wallet: 'محفظة',
    pending: 'قيد الانتظار',
    confirmed: 'مؤكد',
    assigned: 'تم التعيين',
    inProgress: 'قيد التنفيذ',
    completed: 'مكتمل',
    cancelled: 'ملغي',
  },

  // ═══════════════════════════════════════════════════════════
  // القائمة الجانبية - Sidebar
  // ═══════════════════════════════════════════════════════════
  sidebar: {
    dashboard: 'لوحة التحكم',
    orders: 'الطلبات',
    customers: 'العملاء',
    drivers: 'السائقين',
    suppliers: 'الموردين',
    reports: 'التقارير',
    settings: 'الإعدادات',
    support: 'الدعم الفني',
    users: 'المستخدمين',
    roles: 'الأدوار',
    notifications: 'الإشعارات',
    profile: 'الملف الشخصي',
    billing: 'الفواتير',
    analytics: 'التحليلات',
  },
};

export default ar;
